import React from 'react'
import styled from 'styled-components'

const OuterContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`

const InnerContainer = styled.div`
  text-align: center;
  width: 450px;
`

export function Layout({ children }) {
  return (
    <OuterContainer>
      <InnerContainer>{children}</InnerContainer>
    </OuterContainer>
  )
}
